export type SubscriptionSaveOutcome = 'reload' | 'refresh' | 'stay';

/**
 * What the team access page does once a save's subscriptions are created.
 * A full success reloads it. Anything less leaves it open with a warning, and
 * then whatever was created has to be read back: otherwise the page still
 * counts it as a pending change and the next Save buys it again -- e.g. a
 * second combined Database Records pack after the legacy packs failed to
 * cancel.
 */
export const subscriptionSaveOutcome = (
  results: ReadonlyArray<{ success?: boolean } | null | undefined>,
  legacyCancelFailed: boolean,
): SubscriptionSaveOutcome => {
  if (!legacyCancelFailed && results.every((result) => result?.success)) {
    return 'reload';
  }
  return results.some((result) => result?.success) ? 'refresh' : 'stay';
};
